
<script>
import { defineComponent } from 'vue'

import { useToast } from "vue-toastification";

//data
import { getGalleryInfo,getGalleryOptions } from '@/services/serviceGallery';
import { getPhotosPreviewByGallery } from '@/services/servicePhoto';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
  name: 'OnePhotoToComponent',
	data() {
		return {
			isLoading:false,
			gallery: [],
			photos: [],
			optionsGalleries: [],
			selectedGallery:''
		}
	},
  props: {
	'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String
  },
  emits: ["changeAfterSelect"],
  components: {
    
  }
  ,mounted () {

  },
  
	methods: {
		
		//tinymce select one photo
		//natiahne fotky pre vyber jednej do clanku
		loadPhotos:function(){

			getGalleryInfo({galleryId:this.selectedGallery}).then(response => {
				if(!response.statusText){
					this.gallery = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
			this.isLoading=true

			getPhotosPreviewByGallery({galleryId:this.selectedGallery}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.photos = response.photos;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		loadGalleries:function(){
				
			this.isLoading=true
			
			getGalleryOptions().then(response => {
				if(!response.statusText){
					this.optionsGalleries = response.optionsGalleries;
					this.isLoading=false
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		

		onSelect:function(e){
			this.$emit('changeAfterSelect', e)
			this.toast.success(this.$t('msgCore.photoWasSelected'));
		},

		onCloseModal:function(){
			this.modalObject.hide();
		}

	},
	
	watch: {
		modalId() {
			this.loadGalleries();
		},
	},
	
	created() {

	}
})
</script>

<template>
  <div>

	<div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">	

			<div class="modal-content">
				
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Preview') }} <b><span>{{ gallery.title }}</span></b></h6>
				</div>
				
				<div class="modal-body">
					<div class="form-group col-md-4 col-12">
						<label><b>{{ $t('msgCore.Gallery') }}</b></label>
						<select v-model='selectedGallery' class="form-control form-control-sm" v-on:change="loadPhotos()" >
							<option  value="">{{ $t('msgCore.selectGallery') }}</option>
							<option v-for="(option) in optionsGalleries" :value="option.value" :key="option">{{ option.title }}</option>
						</select>
					</div>

					<div class="row">
						<div class="col-12">
							<div v-for="photo in photos" class="crop_gallery2" :key="photo">
								<img :src="photo.photoData" :title="photo.title">
								<button type="button" v-on:click="onSelect(photo.id)" :title="$t('msgCore.btnSelectPhoto')" id="myModalBtn" class="btn btn-primary btn-sm" style="position:absolute; bottom:0; right:0;"><i class="smire-icon fas fa-check"></i> Vyber</button>
							</div>
						</div>
					</div>						
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>

    

  </div>
</template>